module.exports = __webpack_public_path__ + "static/media/overall-speedometer.2126e887.svg";